import React from 'react';

function FundEvents() {
  return (
    <div>
      <h1>Upcoming Events</h1>
    </div>
  );
}

export default FundEvents;
